module.exports = {"513402001":"城北街道","513402002":"城南街道","513402003":"古城街道","513402101":"鹿厂镇","513402102":"黎溪镇","513402103":"通安镇","513402104":"太平镇","513402105":"益门镇","513402106":"绿水镇","513402107":"云甸镇","513402108":"新发镇","513402109":"关河镇","513402110":"彰冠镇","513402111":"木古镇","513402112":"六华镇","513402113":"小黑箐镇","513402201":"内东乡","513402202":"树堡乡","513402203":"新安傣族乡","513402204":"槽元乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513402.json
// module id = 2562
// module chunks = 0